import load from '@kk/load';
import toast from '@kk/toast';

export function loadImg(url, showLoading = true, showToast = true) {
    showLoading && loading.show();
    if (typeof url === 'string') url = [url];

    const length = url.length;
    const time = Math.max(length * 1200, 5000);

    return load(url, time)
        .then(() => {
            showLoading && loading.hide();
            return true;
        })
        .catch((err) => {
            showLoading && loading.hide();
            showToast && toast.show(err);
            console.error('loadImg', err);
            return false;
        });
}
